import { NextImage } from "./NextImage";

export { NextImage };
